import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as MonsterboardIcon } from './monsterboard.svg';

export const Monsterboard = IconHOC(MonsterboardIcon);
